import { render, staticRenderFns } from "./ViewInactiveSyllabusInstances.vue?vue&type=template&id=014aafa8&scoped=true"
import script from "./ViewInactiveSyllabusInstances.vue?vue&type=script&lang=js"
export * from "./ViewInactiveSyllabusInstances.vue?vue&type=script&lang=js"
import style0 from "./ViewInactiveSyllabusInstances.vue?vue&type=style&index=0&id=014aafa8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "014aafa8",
  null
  
)

export default component.exports